import React, { useState, useEffect, useRef, useContext, useMemo } from "react";
import TableStyle from "components/Content/Table/TableStyle.module.css";
import { apiGet, apiPost } from "app/Services/ApiService";
import { apiUrls } from "common/ApiUrls";
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Slide, TextField } from "@mui/material";
import { LoadingButton } from "@mui/lab";
import ButtonStyle from "components/Button/ButtonStyle.module.css";

import ListIcon from "@mui/icons-material/List";
import LoaderAnimation from "pages/LoaderAnimation";
import HWStatementDetail from "components/HWStatementDetail";
import { PrivateRoutesContext } from "app/PrivateRoutesContext";
import AximTooltip from "components/AximTooltip";
import TimeFrameDateSelector from "components/TimeFrameDateSelector"
import { PortalNames } from "common/Portals";
import { Utils } from "common/Utils";

function HWStatement () {
  const { companyId, userInfo } = useContext(PrivateRoutesContext);
  const [time, setTime] = useState("Monthly");
  const [checkingData, setCheckingData] = useState(true);


  const report = useRef("");

  const [doShowDialog, setDoShowDialog] = useState(false);
  const [dialogTitle, setDialogTitle] = useState("");
  const [dialogText, setDialogText] = useState("");

  const [hwStatements, setHwStatements] = useState([]);
  const [isExporting, setIsExporting] = useState(false);

  useEffect(() => {
    setTimeout(() => {
      setCheckingData(false);
    }, 2000);
  }, []);

  const canDownload = useMemo(() => {
    return !Utils.isBroker(userInfo);
  },[userInfo]);

  const loadHWStatements = (time, startDate, endDate, name) => {
    setCheckingData(true);
    setTime(time);

    apiGet(apiUrls.getHWStatementDetails(companyId, startDate, endDate, name)).then((response) => {
      setHwStatements(response.data);

      setCheckingData(false);
    });
  }

  const handleExport = () => {
    if (hwStatements.length > 0) {
      setIsExporting(true);
      let pdfHtml = Utils.hwStatementReport(report.current.outerHTML);
      const formData = new FormData();
      formData.append("htmlData", pdfHtml);

      console.log("Exporting");
      // console.log(pdfHtml)
      let selectedCompany = localStorage.getItem(`selectedCompanyId`);

      apiPost(apiUrls.exportReport(selectedCompany, "HWStatement"), formData, {
          "content-type": "multipart/form-data",
          Accept: "*/*",
      })
        .then((response) => {

          setDialogTitle("Export HW statement to PDF")
          setDialogText("Exporting HW statement to PDF, redirecting to reports page")
          setDoShowDialog(true);

          setTimeout(() => {
            window.location.href = `/${PortalNames.Employer.Path}/reports`
          }, 1000);

        })
        .catch((e) => {
          setDialogTitle("Export error")
          setDialogText("Failed to export to pdf")
          setDoShowDialog(true);
        })
        .finally(() => {
          setIsExporting(false);
        });
    }
    else {
      setDialogTitle("No Data")
      setDialogText("There are no rows to export.")
      setDoShowDialog(true);
    }
  }

  const handleCloseDialog = () => {
    setDoShowDialog(false);
  }

  return (
    <div>
          <div className={TableStyle.tableWrapper}>
            <div>
              <Box className="d-flex justify-content-end align-items-center">
                <TimeFrameDateSelector payPeriodsUrl={apiUrls.getHWPayPeriods(companyId)}
                                        handleView={loadHWStatements}
                                        isViewEnabled={!checkingData}
                                        doUseName={true} />

                {canDownload ? 
                  <AximTooltip title={hwStatements.length === 0 ? "Load Records with View button to export" : ""}>
                    <span>
                      <LoadingButton
                        variant="outlined"
                        onClick={handleExport}
                        className={ButtonStyle.CsubmitBtn}
                        startIcon={<ListIcon />}
                        disabled={hwStatements.length == 0 || checkingData}
                        loading={isExporting}
                        loadingPosition="start"
                      >
                        Export to PDF
                      </LoadingButton>
                    </span>
                  </AximTooltip>
                : null}
              </Box>

            </div>

            {checkingData ? (
              <LoaderAnimation timeout={60000} centerAtPage={true}/>
            ) : (
              hwStatements.length === 0 && <span>No Record Found</span>
            )}

            <div
              ref={report}
            >
              {

                hwStatements.map((statementDetails, i) => {
                  return (
                  <HWStatementDetail
                    key={i}
                    statementDetails={statementDetails}
                    statementDisclaimers={hwStatements[0].statementDisclaimers}
                    time={time} />)
                })}
            </div>
          </div>

      <Dialog
        open={doShowDialog}
        onClose={handleCloseDialog}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{dialogTitle}</DialogTitle>
        <DialogContent>{dialogText}</DialogContent>

        <DialogActions>
          <Button onClick={handleCloseDialog} color="primary" variant="outlined">
            Close
          </Button>
        </DialogActions>
      </Dialog>
      </div>
  );
}

export default HWStatement;
